<template>
  <b-app :dark="dark" :style="{ backgroundColor: site_background }">
    <b-password-protection
      v-if="requirePassword"
      :prefix="prefix"
      :encrypted-access-string="encryptedAccessString"
    >
      <router-view v-if="!config_error"/>
    </b-password-protection>
    <div v-else>
      <router-view v-if="!config_error"/>
    </div>
    <b-error-alert v-model="config_error" :message="error_message"/>
    <b-development-banner
      :visible="dev_mode"
    >
      <b-language-debug-toggle
        class="debug ml-6"
      />
    </b-development-banner>
    <template v-slot:footer>
      <div class="footer">
        <p v-html="$t('developed_by')"/>
      </div>
    </template>
  </b-app>
</template>

<script>
// http://localhost:8080/#/?id=18831%23wFBEWg1gbzNfjwRrHJgP4UloGISwb0Bf41If5g9V4tI%3D&encryptedAccessString=U2FsdGVkX1%2FSE%2BiQ%2FSjKNJIDL1zVdRcOpcyZo3Y7hbT4vU15BVbKAVd54g1Fwt0W // encrypt(jdmtregmask-1791129175300)
// http://localhost:8080/#/?id=18831%23wFBEWg1gbzNfjwRrHJgP4UloGISwb0Bf41If5g9V4tI%3D
// http://localhost:8080/#/?id=6626985%23g3eOMZ6K3euzb0mbOB5guxlSZeBFlJQgM4Id6AcbgE%3D -> Bereits gestartet
// http://localhost:8080/#/?id=6669952%238JbhsKsOE32k12uL6OgFXdpZFco7L7XIf11VzEisns%3D -> Keine anonyme Anmeldung möglich
// http://localhost:8080/#/?id=6586318%23a8yEJuqxJFxjAzSpv0CzjoOvoRzIWxSFXV5ZLox40%3D&module=mentoring&client=27 -> Volle Ausprägung
// http://localhost:8080/#/?id=6669875%23ykOF8PD73mheipNEWucb9hfbFMFhvg4Gmqid7tzyz10%3D -> Max Teilnehmerzahl erreicht
// http://localhost:8080/#/?id=5685615%23JvDmCfnHoWVlikqwshhTcy2yURS7ZCKwAf0024RA%3D -> Auf Warteliste setzen
// http://localhost:8080/#/?113847%23ZSUG87LqnXG2vGHubXTcbaSJpjGpueWFrz3fE9fYCNw%3D -> Tags Ausblenden/Obligatorisch
import { mapGetters } from "vuex";

export default {
  name: "App",
  provide: {
    module: window.bomconfig?.module,
    client_id: window.bomconfig?.client_id,
  },
  data: () => ({
    config_error: false,
    error_message: "",
    dark: !!window.bomconfig.darkmode,
    requirePassword: false,
    prefix: "regmask",
    encryptedAccessString: "",
  }),
  created() {
    if (!window.bomconfig) {
      this.setError(this.$t("b.error.no_bom_config"));
      return;
    }
    this.$bomify.$message.debug(true);

    if (window.bomconfig?.trust_messages_from){
      this.$bomify.$message.addTrustedSources(window.bomconfig?.trust_messages_from);
    }
    this.$bomify.$message.addTrustedSources([`${window.location.protocol}//${window.location.host}`]);

    this.assertRequiredConfigs();
    this.requirePassword = !!(window?.bomconfig?.security?.require_password);
    if (this.requirePassword) {
      this.prefix = window?.bomconfig?.security?.prefix || this.prefix;
      this.encryptedAccessString = this.$route.query.encryptedAccessString;
    }
    if (window.bomconfig.color) {
      this.$bomify.$vuetify.theme.themes.light.primary = window.bomconfig.color;
    }
    if (window.bomconfig.add_modules) {
      window.bomconfig.add_modules.forEach((module_definition) => {
        if (!this.$bom[module_definition.name]) {
          this.$bom.addModule(module_definition);
        }
      });
    }
  },
  computed: {
    dev_mode() {
      return !window.bomconfig.production;
    },
    ...mapGetters("config", {
      getThemeVariable: "getThemeVariable",
    }),
    site_background() {
      return this.getThemeVariable("site_background");
    },
  },
  methods: {
    assertRequiredConfigs() {
      const required_config_keys = [
        "api_url",
        "api_token",
        "client_id",
        "module",
      ];
      required_config_keys.forEach((required_key) => {
        this.assertConfig(required_key);
      });
    },
    assertConfig(entry) {
      if (!window.bomconfig[entry]) {
        this.setError(this.$t("b.error.missing_config_entry", { entry }));
      }
    },
    setError(message) {
      this.config_error = true;
      this.error_message = `ERROR: ${message}`;
    },
  },
};
</script>

<style scoped>
div.footer {
  padding-top: 30px;
  width: 100%;
}

div.footer > p {
  width: 100%;
  text-align: center;
  margin-bottom: 0;
  padding-bottom: 0;
  font-size: 0.8rem;
  color: grey;
}

div.footer >>> p * {
  color: grey;
  text-decoration: none;
}

.debug >>> .v-label {
  color: black;
  font-size: 16px;
}
.debug >>> .v-input--selection-controls__input * {
  font-size: 20px;
}
</style>
